import styled, { css } from 'styled-components';

export const Wrapper = styled.header`
  ${({ theme, paddingBottom }) => css`
    align-items: center;
    background: ${theme.v3.colors.neutral[100]};
    display: flex;
    padding: ${paddingBottom ? '16px 24px' : '16px 24px 0px'};
    border-radius: ${theme.v3.border.radius.xl};
    
    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
      align-items: flex-start;
    }    
  `}
`;

export const TooltipWrapper = styled.div`
  display: flex;
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};  
    font-size: ${theme.v3.font.sizes['1xlarge']};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[30]};
    margin: 0;
  `}
`;

export const Description = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};    
    color: ${theme.v3.colors.neutral[60]};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin-left: 6px;
    position: relative;
    top: 2px;
  `}
`;

export const ChildrenContainer = styled.span`
  ${({ position }) => css`
    justify-self: ${position};
  `}
`;
